import React from 'react';
import { FormattedMessage } from 'react-intl';
import core from '@gin-betting/core';
import { capitalize } from 'lodash';

import globalMessages from 'messages';
import { LiveLabel } from 'components';
import './dateTime.scss';

const {
    utils: { formatTimeAndDate },
} = core;

interface Props {
    startTime: string;
}

const DateTime: React.FC<Props> = ({ startTime }) => {
    const { isToday, date, time } = formatTimeAndDate(startTime);

    return (
        <React.Fragment>
            <LiveLabel isFaded={true} />

            <div styleName="wrapper">
                <div styleName="time">{isToday ? time : capitalize(date)}</div>
                <div styleName="date">
                    {isToday ? (
                        <FormattedMessage {...globalMessages.todayText} />
                    ) : (
                        time
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default DateTime;
